<template>
  <img class="rackman-image" :src="`img/icons/${image}`" height="30px" width="30px" />
  <!-- <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="300.000000pt" height="300.000000pt" viewBox="0 0 300.000000 300.000000"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M1260 2579 c-410 -104 -751 -189 -757 -189 -10 0 -13 -200 -13 -964
0 -934 1 -966 20 -1010 48 -113 146 -174 295 -183 78 -5 97 -1 864 193 606
153 790 203 810 220 l26 22 3 892 c1 585 -1 905 -8 930 -13 48 -50 66 -106 51
-22 -5 -50 -12 -64 -15 -14 -3 -344 -86 -735 -186 -390 -99 -711 -180 -713
-180 -2 0 -3 -422 -2 -937 1 -516 2 -948 1 -959 -1 -20 -5 -21 -38 -14 -21 5
-67 13 -102 19 -88 14 -160 63 -192 128 l-24 48 -5 935 c-3 514 -9 944 -13
955 -5 11 0 8 9 -7 11 -17 25 -26 34 -23 16 5 597 152 1158 294 l343 87 34
-23 c19 -13 34 -29 32 -35 -2 -13 115 -82 158 -92 28 -7 29 -6 10 7 -11 8 -53
33 -92 56 -71 41 -73 43 -73 82 0 52 -35 89 -82 88 -18 0 -368 -86 -778 -190z
m806 144 c17 -17 15 -18 -34 -24 -29 -4 -60 -10 -69 -14 -20 -8 -484 -124
-578 -145 -33 -7 -64 -17 -70 -20 -5 -4 -23 -10 -40 -13 -16 -3 -156 -37 -310
-77 -386 -98 -389 -99 -408 -96 -60 9 0 43 108 62 17 2 44 9 60 14 33 10 182
50 205 55 8 2 125 31 260 65 547 139 826 208 842 209 9 1 24 -7 34 -16z m392
-225 c9 -9 12 -226 12 -913 0 -1028 11 -923 -95 -949 -69 -16 -1064 -268
-1295 -327 -85 -22 -160 -37 -167 -35 -11 4 -13 186 -13 939 l0 934 108 25
c252 61 719 180 737 187 23 10 504 125 580 139 74 14 119 14 133 0z"/>
<path d="M1705 1913 c-230 -49 -439 -250 -511 -492 -26 -86 -24 -251 4 -320
45 -114 127 -193 242 -231 86 -29 212 -24 317 13 174 61 341 227 415 410 32
79 33 87 33 217 0 124 -2 139 -26 190 -27 58 -90 130 -148 170 -40 28 -159 60
-215 59 -23 0 -72 -7 -111 -16z m253 -25 c155 -57 242 -195 242 -383 0 -377
-418 -727 -746 -627 -124 38 -221 138 -254 262 -19 70 -15 206 9 286 36 120
136 265 242 348 162 129 351 171 507 114z"/>
<path d="M1690 1771 c-218 -69 -383 -289 -383 -510 1 -117 41 -195 130 -247
42 -24 59 -28 133 -28 65 0 99 5 144 22 209 80 366 295 366 501 0 85 -13 130
-53 183 -48 64 -122 98 -211 97 -39 0 -96 -8 -126 -18z m201 -1 c87 -24 152
-98 169 -193 49 -267 -209 -576 -485 -580 -295 -5 -348 376 -88 632 121 118
282 175 404 141z"/>
<path d="M1763 1651 c-48 -35 -83 -88 -83 -126 0 -35 -24 -86 -58 -122 -67
-72 -174 -224 -174 -248 0 -61 79 -88 123 -43 11 13 63 78 115 145 80 104 102
125 148 148 92 45 142 137 66 121 -17 -3 -44 -9 -61 -12 l-30 -6 14 33 c11 28
22 37 63 50 57 18 66 38 28 68 -40 31 -101 28 -151 -8z m145 3 c34 -24 26 -39
-28 -53 -46 -12 -53 -18 -75 -62 -14 -26 -25 -50 -25 -53 0 -3 32 4 71 15 39
11 74 17 77 14 18 -17 -83 -105 -122 -105 -15 -1 -55 -45 -141 -155 -102 -132
-123 -155 -147 -155 -17 0 -34 10 -47 27 -26 32 -30 24 116 210 88 112 103
136 103 168 0 57 42 119 105 153 29 16 87 14 113 -4z"/>
</g>
</svg> -->

</template>

<script>
export default {
  props: {
    filled: {
      type: Boolean
    }
  },
  data() {
    return {}
  },
  computed: {
    image() {
      if (this.filled) {
        return 'rackman_filled.png'
      }

      return 'rackman_outlined.png'
    }
  }
}
</script>

<style>
.rackman-image {
  margin: 3px;
  /* background-color: green;
  border: 1px solid black; */
}
</style>